module.exports = __webpack_public_path__ + "img/introduction.32c1986b.png";